<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/code_of_conduct/code_of_conduct_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'code_of_conduct.Code of Conduct' | translate }}</p>
        </div>
        
        <div class="paragraph">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3">
                    <div style="background-color: white;">
                        <img [src]="baseApiUrl + '/uploads/images/code_of_conduct/code_of_conduct_2.svg'" alt="">
                        <div class="desc">
                            <h2>{{ 'code_of_conduct.BFIs Code of Conduct' | translate }}</h2>
                            <p>For​ that,​ the​ Banking​ and​ Financial​ Institutions​ Code​ of​ Conduct​ (“BFI​ Code”)​ has​ been​ established​ by​ multiple​ stakeholders​ to​ set​ out​ ethical​ standards​ of​ responsible​ practices​ for​ the​ Banking​ and​ Financial​ Institutions​ in​ Cambodia​ whereby​ consumers​ can​ expect​ and​ trust​ when​ dealing​ with​ Banking​ and​ Financial​ Institutions.
                            </p>
                            <p>See​ the​ current​ version​ of​ the​ BFI​ Code​ below:</p>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="row" style="margin-top: 20px;">
                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                            <img [src]="baseApiUrl + '/uploads/images/code_of_conduct/code_of_conduct_5.png'" style="width: 100%; height: auto;" alt="">
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12 img-desc" style="color: #005EB8;">
                                            <p>{{ 'code_of_conduct.Banking and Financial Institutions Code of Conduct' | translate }}</p>
                                            <p>{{ 'code_of_conduct.4th March 2022' | translate }}</p>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-3">
                                                    <a [href]="baseApiUrl + '/uploads/pdf_files/code_of_conduct_en.pdf'" target="_blank"><button class="btn btn-primary" style="font-size: 10px;">{{ 'code_of_conduct.ENG' | translate }}</button></a>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-4">
                                                    <a [href]="baseApiUrl + '/uploads/pdf_files/code_of_conduct_kh.pdf'" target="_blank"><button class="btn btn-primary" style="font-size: 10px;">{{ 'code_of_conduct.KH' | translate }}</button></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-content-poster" style="background-color: #EDEDED; margin-top: 20px;">
        <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
        <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
    </div>
</main>